<template>
  <dl :class="formType" class="email">
    <dt>이메일</dt>
    <dd class="form">
      <v-input v-model="request.businessEmail" target="email" @custom-input="updateEmail" />
    </dd>
    <dd v-if="formType == 'modify'" class="bt">
      <v-button @handleClick="cancelClick" class="btn22" text="수정 취소" />
      <v-button @handleClick="submitClick" class="btn21" text="수정 완료" :disabled="checkEmail" />
    </dd>
  </dl>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VInput from '@/components/atoms/VInput';
import VButton from '@/components/atoms/VButton';

export default {
  components: {
    VInput,
    VButton,
  },
  props: {
    formType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      request: {
        businessEmail: '',
      },
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    checkEmail() {
      const reg_email = /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;
      return !reg_email.test(this.request.businessEmail);
    },
  },
  methods: {
    ...mapActions('userInfo', ['setModifyBusinessEmail']),
    updateEmail() {
      this.$emit('update', {
        request: this.request,
        isState: !this.checkEmail,
      });
    },
    cancelClick() {
      this.$emit('cancel-click');
    },
    async submitClick() {
      const apiReturn = await this.setModifyBusinessEmail({
        ...this.request,
        businessType: this.userInfo.businessType,
      });
      if (apiReturn === 0) {
        this.$emit('cancel-click');
      }
    },
  },
};
</script>
<style lang="scss"></style>
